import type { FC } from 'react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OneInput } from '@yy/one-ui'
import { FormItem } from '@/bizComponent/AntdForm/DynamicFormItemGroup'
import RULES from '../../../../rules'

interface IProps {
  defaultValue?: string
  required?: boolean
}
export const PackDescField: FC<IProps> = (props) => {
  const { defaultValue, required = false } = props
  const { t } = useTranslation()

  return (
    <FormItem
      name="provider_package_desc"
      initialValue={defaultValue}
      label={`${t('provider.package.desc')}${required ? '' : t('logistics.create.optional')}`}
      required={required}
      rules={RULES.provider_package_desc({
        isRequired: required,
      })}
    >
      <OneInput placeholder={t('common.input.placeholder')} />
    </FormItem>
  )
}
